module.exports = __webpack_public_path__ + "static/img/banner2.1cbafae5.jpg";